import React from 'react';
import PropTypes from 'prop-types';
import { isInternalURL } from '@plone/volto/helpers';
import { flattenToAppURL } from '@plone/volto/helpers';
import { FormattedMessage, injectIntl } from 'react-intl';
import { UniversalLink, Image } from '@plone/volto/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Icon } from '../../'

import { Container, Grid } from 'semantic-ui-react';

const IconListing = ({ items, linkTitle, linkHref, isEditMode, blockTitle }) => {

	let href = (linkHref?.[0]?.['@id']) || '';
	let link = href ? flattenToAppURL(href) : '';

	return (
		<div className='directLinks pb-4'>
			<Container>
				{blockTitle && <h3 className="fsc-h2 directLinks__title mt-0">{blockTitle}</h3>}
				<Grid className="directLinks__list list-unstyled ">
					<Grid.Row as="ul" columns={12} className='my-0' >
						{items.map((item) => (
							<Grid.Column as="li" key={item['@id']} mobile={6} tablet={4} computer={3} widescreen={2} >
								<UniversalLink
									className="directLinksItem"						
									href={item?.getRemoteUrl ? item?.getRemoteUrl : item['@id']}>
									<span aria-hidden="true" className="directLinksItem__icon__wrapper">
										{item?.content_icon && (<Icon name={item.content_icon} className="directLinksItem__icon" />)}
									</span>
									<span className="directLinksItem__text">
										{item.title || item.id}
									</span> 
								</UniversalLink>
							</Grid.Column>
						))}
					</Grid.Row>
				</Grid>

				{link &&
					<p className="readMoreItem mb-4 d-print-none">
						<UniversalLink href={link} className="readMoreItem__btn ui button primary">
							{linkTitle ? (<span>{linkTitle}</span>) :
								(<FormattedMessage id="See all" defaultMessage="See all" />)}
							<span className="visually-">{blockTitle}</span>
							<FontAwesomeIcon icon={faChevronRight} className="readMoreItem__icon ms-3" />
						</UniversalLink>
					</p>
				}
			</Container>
		</div>
	);
}

IconListing.propTypes = {
	linkHref: PropTypes.arrayOf(PropTypes.any),
	items: PropTypes.arrayOf(PropTypes.any).isRequired,
	linkMore: PropTypes.any,
	isEditMode: PropTypes.bool,
};

export default IconListing;
